<template>
  <div class="bg-white py-5 border-light border-bottom">
    <div class="container">
      <div class="secondary-heading">
        {{ articleData.category }}
      </div>
      <h1 class="h2">
        {{ articleData.title }}
      </h1>
      <div class="wf-article-date">
        {{ articleData.date }}
      </div>
      <div
        class="wf-article-description-top"
        v-html="articleData.description"
      ></div>

      <div class="wf-article-media">
        <pc-article-media
          :src="articleData.media1.src.replace('~', '')"
          :alt="articleData.media1.alt"
          :caption="articleData.media1.caption"
        />
        <pc-article-media
          :src="articleData.media2.src.replace('~', '')"
          :alt="articleData.media2.alt"
          :caption="articleData.media2.caption"
        />
        <pc-article-media
          :src="articleData.media3.src.replace('~', '')"
          :alt="articleData.media3.alt"
          :caption="articleData.media3.caption"
        />
        <pc-article-media
          :src="articleData.media4.src.replace('~', '')"
          :alt="articleData.media4.alt"
          :caption="articleData.media4.caption"
        />
      </div>

      <div
        class="wf-article-description-bottom"
        v-html="articleData.descriptionBottom"
      ></div>

      <div
        class="wf-article-tags mt-5"
        v-if="articleData.primaryTag || articleData.secondaryTag"
      >
        <div class="call-to-action-links">
          <h4 class="label mb-2">In this article:</h4>
          <ul class="list-unstyled d-flex flex-row flex-wrap mx-n1">
            <li class="p-1" v-if="articleData.primaryTag">
              <a
                class="btn btn-white shadow-sm h-100 w-100"
                :href="tagName(articleData.primaryTag)"
              >
                {{ articleData.primaryTag }}

                <span class="png-icon png-icon-icons-glyph--k-arrow-right-sm">
                </span>
              </a>
            </li>
            <li class="p-1" v-if="articleData.secondaryTag">
              <a
                class="btn btn-white shadow-sm h-100 w-100"
                :href="tagName(articleData.secondaryTag)"
              >
                {{ articleData.secondaryTag }}

                <span class="png-icon png-icon-icons-glyph--k-arrow-right-sm">
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PcArticleMedia from "./pc-article-media.vue";
export default {
  props: {
    articleData: {
      required: true
    }
  },
  components: {
    PcArticleMedia
  },
  methods: {
    tagName(tagName) {
      if (tagName == "rug") {
        return "#";
      } else {
        return encodeURI("/tags/?name=" + tagName);
      }
    }
  }
};
</script>
